<template>
  <div class="carousel-banner">
    <splide :options="carousel" ref="slider">
      <splide-slide v-for="(block, idx) in blocks" :key="idx" class="cta-banner cta-item">
        <VPic
          v-if="block.mobileImage.src !== null || block.desktopImage.src !== null"
          :media="{
            res: '--tablet-up',
            alt: block.title
          }"
          :mobile_media="block.mobileImage.src !== null ? block.mobileImage : block.desktopImage"
          :desktop_media="block.desktopImage.src !== null ? block.desktopImage : block.mobileImage" />

        <p class="error" v-else>Please upload an image</p>

        <div :class="['banner-content', `${block.text_colour}-text`]">
          <p v-if="block.sub_title !== ''" class="banner-sub-title">{{ block.sub_title }}</p>
          <h4 v-if="block.title !== ''" class="banner-title">{{ block.title }}</h4>
          <p v-if="block.body_text !== ''" class="banner-text">{{ block.body_text }}</p>
          <a v-if="block.cta_url !== null" :href="block.cta_url">{{ block.cta_text }}</a>
        </div>
      </splide-slide>
    </splide>
  </div>
</template>

<script>
import VPic from './VPic'
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'

export default {
  name: 'CarouselBanner',

  props: ['settings', 'blocks'],

  components: {
    VPic,
    Splide,
    SplideSlide
  },

  data() {
    return {
      carousel: {
        type: 'loop',
        autoplay: this.settings.enable_autoplay,
        speed: 1000,
        interval: this.settings.autoplay_speed
      }
    }
  },

  mounted() {
    const arrow = document.querySelectorAll('.splide__arrow')
    arrow.forEach((arrow) => {
      arrow.addEventListener('click', () => {
        this.onArrowClick()
      })
    })
  },

  methods: {
    onArrowClick() {
      if (this.settings.enable_autoplay) {
        this.$refs.slider.splide.Components.Autoplay.pause(99)
      }
    }
  }
}
</script>
